

export function navigatePreserveSearchParams(path: string, navigate: (path: string) => void) {
  const searchParams = new URLSearchParams(window.location.search);
  const p = searchParams.size === 0 ? path : path + "?" + searchParams.toString();
  return navigate(p);
}
